// src/components/ErrorBoundary.tsx
import React from "react";
import { showCrashOverlay } from "../lib/crashOverlay";

type Props = { children: React.ReactNode };

export default class ErrorBoundary extends React.Component<Props> {
  componentDidCatch(error: any, info: any) {
    showCrashOverlay("React render crash (ErrorBoundary)", {
      error: error instanceof Error ? { name: error.name, message: error.message, stack: error.stack } : error,
      info,
    });
  }

  render() {
    return this.props.children;
  }
}
